"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgStatusWarning = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ fill: "currentColor", height: 24, width: 26, xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "m25.569 18.782-9.765-16.72A3.206 3.206 0 0 0 14.62.918a3.298 3.298 0 0 0-3.218 0c-.49.274-.898.668-1.184 1.144L.431 18.782a3.091 3.091 0 0 0 .002 3.148c.283.478.69.875 1.18 1.151s1.046.42 1.611.419h19.552a3.275 3.275 0 0 0 1.61-.419c.491-.276.898-.672 1.181-1.15a3.09 3.09 0 0 0 .002-3.149z", fill: "#fff" }), (0, jsx_runtime_1.jsx)("g", __assign({ fill: "#current" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M13 8.21c-.296 0-.58.116-.79.32a1.08 1.08 0 0 0-.327.773v5.46c0 .29.118.568.327.772.21.205.494.32.79.32.296 0 .58-.115.79-.32a1.08 1.08 0 0 0 .327-.772v-5.46c0-.29-.117-.568-.327-.773a1.13 1.13 0 0 0-.79-.32zM13 19.132c.617 0 1.117-.49 1.117-1.093s-.5-1.092-1.117-1.092-1.117.49-1.117 1.093.5 1.092 1.117 1.092z" }) }))] }))); };
exports.default = SvgStatusWarning;
